import { strings } from "../strings";

export function NotFoundPage() {
  return (
    <div role="alert" className="eg-error-page">
      <h1>{strings.errors.notFoundTitle}</h1>
    </div>
  );
}
